export enum ChatType {
  My = 'My',
  Queued = 'Queued',
  Other = 'Other',
  Supervised = 'Supervised',
  Unassigned = 'Unassigned',
}
